module.exports = __webpack_public_path__ + "img/99-2-722x800.77889114.jpg";